module.exports = __webpack_public_path__ + "static/media/Rectangle_6@2x.13b995de.png";